import { render, staticRenderFns } from "./Firmenliste.vue?vue&type=template&id=3c228a04"
import script from "./Firmenliste.vue?vue&type=script&lang=js"
export * from "./Firmenliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports